const SliderWithTwoHalf = () => {
    $('.slider-with-two-half .btn-open-list').click(() => {
      const el = $('.slider-with-two-half .list-block');
      const elImg = $('.slider-with-two-half .open-items-list');
      if(el.hasClass('hide')) {
        el.slideDown(300).removeClass('hide').addClass('grid');
        elImg.text('-');
      } else {
        el.slideUp(300).addClass('hide').queue(function () {
          $(this).removeClass('grid').dequeue();
          elImg.text('+');
        })
      }
    });
}

export default SliderWithTwoHalf;



// WEBPACK FOOTER //
// ./scripts/components/SliderWithTwoHalf.js